export default __webpack_public_path__ + "static/media/EDF_Hex.b89624c1.svg";